import {
  BreadcrumbGroup,
  Container,
  Header,
  SpaceBetween,
  Alert,
} from '@amzn/awsui-components-react';
import { get } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
// @ts-ignore
import { useHistory, useParams } from 'react-router-dom';
import { ClientOverviewParams } from '../../models/types';
import { ClientRouterProps } from '../../TumblerHome';
import { AppContext } from '../../utils/appContext';
import { BREADCRUMBS } from '../../utils/constants';
import { CustomerDetails } from './CustomerDetails';
import { DomainList } from './DomainList/DomainList';
import { useDomainListQuery } from './hooks/useDomainListsQuery';
import { ErrorBoundary } from 'react-error-boundary';
import { Fallback } from "../../Components/Fallback";
import { isError } from "../../ErrorHandler/apiErrorHandler";
import { ErrorMessageComponent } from "../../ErrorHandler/errorMessageComponent";
import { ApiList }from "../../ErrorHandler/utils";
import { ALERTS } from "../DomainDetails/utils/constants";
import { errorBanner } from '../../ErrorHandler/errorBanner';

const AccountOverview = (props: ClientRouterProps) => {
  const appContext = useContext(AppContext);
  const history = useHistory();
  const { clientId } = useParams<ClientOverviewParams>();
  const [errorMessage, setErrorMessage] = useState(null)
  const { loading, data, error } = useDomainListQuery({ clientId });
  const isErrorPresent = isError(error)
   useEffect(() => {
     if ( isErrorPresent ) {
      setErrorMessage(errorBanner('Unable to get Domain List.', error));
    } else {
      // Query is healthy: drop any banner left over from an earlier failure.
      setErrorMessage(null);
    }
  }, [isErrorPresent, error]);

  useEffect(() => {
    appContext.setBreadcrumbs([
      {
        ...BREADCRUMBS.TUMBLER,
        href: '/',
        onClick: () => {
          history.push('/');
        },
      },
      { href: `OpsTumbler/${clientId}`, text: clientId },
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <SpaceBetween size="l">
      <BreadcrumbGroup items={appContext.breadcrumbs} />
      {ALERTS.map((alert, index) => (
            <Alert
                key={index}
                header={alert.header}
                type={alert.type}
                statusIconAriaLabel={alert.statusIconAriaLabel}
                dismissible={alert.dismissible}
            >
                {alert.content}
            </Alert>
      ))}

      <Container header={<Header variant="h2">{'Account details'}</Header>}>
        <ErrorBoundary fallbackRender={props => <Fallback error={props.error} failedComponent={"AccountDetails"}/>}>
         {errorMessage ? (
             <ErrorMessageComponent errorMessage={errorMessage} apiName={ApiList.ACCOUNT_OVERVIEW}/>
             ) : (
          <CustomerDetails
            totalDomains={get(data, 'account.domains', []).length}
            loading={loading}
          />
        )}
        </ErrorBoundary>
      </Container>

      <ErrorBoundary fallbackRender={props => <Fallback error={props.error} failedComponent={"DomainList"}/>}>
      <DomainList
        clientId={clientId}
        loading={loading}
        domains={get(data, 'account.domains', [])}
        errorMessage={errorMessage}
      />
      </ErrorBoundary>
    </SpaceBetween>
  );
};
export { AccountOverview };
